import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Location, NgTemplateOutlet } from '@angular/common';
import { Router } from '@angular/router';
import { Ag1TitleComponent } from '../../core/components/ag1-title/ag1-title.component';
import { Bind } from '@openng/optimus-ui/bind';
import { Button } from '@openng/optimus-ui/button';

@Component({
  selector: 'ag-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1TitleComponent, NgTemplateOutlet, Bind, Button],
})
export class ServerErrorComponent {
  private router = inject(Router);
  private location = inject(Location);

  constructor() {}

  goBack(): void {
    window.location.reload();
    setTimeout(() => {
      this.location.back();
    });
  }
}
